module.exports = __webpack_public_path__ + "img/qfcm-img3.e54b4dfe.png";